import 'slick-carousel';

const handler = ( $ ) => {
	// toggles
	$( '.bookmarks-toggles .toggle-title' ).on( 'click', function ( e ) {
		e.preventDefault();
		const $title = $( this ),
			$toggle = $title.parent(),
			$content = $toggle.find( '.toggle-content' );

		if ( $toggle.hasClass( 'is-active' ) ) {
			$content.slideUp( 'fast', function () {
				$title.removeClass( 'is-active' );
				$toggle.removeClass( 'is-active' );
			} );
		} else {
			$( '.bookmarks-toggles .toggle-content' )
				.not( $content )
				.slideUp( 'fast' );
			$( '.bookmarks-toggles .toggle-title' )
				.not( $title )
				.removeClass( 'is-active' );

			$content.slideToggle( 'fast', function () {
				$title.toggleClass( 'is-active' );
			} );
		}
	} );

	// close complete-your-profile notice
	$( '.complete-your-profile-notice .close' ).on( 'click', function ( e ) {
		e.preventDefault();

		$( '.complete-your-profile-notice' ).fadeOut( 'fast', function () {
			document.cookie =
				'wordpress_pen_hide_complete_profile_notice=1; expires=Sun, 1 Jan 2999 00:00:00 UTC; path=/';
		} );
	} );

	// members carousel
	$( '.members-carousel' ).slick( {
		autoplay: false,
		arrows: true,
		dots: false,
		swipe: true,
		slidesToShow: 3,
		cssEase: 'linear',
		pauseOnFocus: false,
		pauseOnHover: true,
		infinite: false,
		prevArrow: '<a href="#" class="slick-prev-btn"></a>',
		nextArrow: '<a href="#" class="slick-next-btn"></a>',
		rows: 0, // Fix vor v1.8.0-1
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
